import {
  RESET
  SET_GRAPH
  SET_NAME
  SET_STEPS
  SET_FIELD_DATA
  SET_IS_HIDDEN
  SET_TYPE_NODE
  SET_LABEL
  SET_CONFIRMATION_MESSAGE
} from './actionTypes'

export reset = ->
  { type: RESET }

export setGraph = (data) ->
  type: SET_GRAPH
  payload: { data }

export setName = (data) ->
  type: SET_NAME
  payload: { data }

export setSteps = (data) ->
  type: SET_STEPS
  payload: { data }

export setFieldData = (data) ->
  type: SET_FIELD_DATA
  payload: { data }

export setIsHidden = (data) ->
  type: SET_IS_HIDDEN
  payload: { data }

export setTypeNode = (data) ->
  type: SET_TYPE_NODE
  payload: { data }

export setLabel = (data) ->
  type: SET_LABEL
  payload: { data }

export setConfirmationMessage = (data) ->
  type: SET_CONFIRMATION_MESSAGE
  payload: { data }
